module.exports = __webpack_public_path__ + "img/price.720651ad.png";